import { useEffect } from "react";
import { useRef, useState } from "react";
import toast from "react-hot-toast";
import API from "src/API2";
import { UPLOAD_URL } from "src/constants";
import "./galleriemanager.css";

const AddImagesModal = ({ setActive }) => {
  const [images, setImages] = useState(null);
  const [type, setType] = useState("");
  const ref = useRef();

  const post = () => {
    const form = new FormData();
    for (let i = 0; i < images.length; i++) {
      form.append("pictures", images[i]);
    }
    form.append("type", type);

    console.log(form)

    toast.promise(
      API.post("/content/gallerieImage", form).then((resp) => {
        console.log(resp)
      }),
      {
        success: "Gallerie pictures added succeffully",
        error: "Something went wrong",
        loading: "Adding new gallerie pictures",
      }
    );
  };

  return (
    <div className="addimagesmodal">
      <div className="wrapperblur">
        <div className="content">
          <div className="input">
            <span>Type</span>
            <select
              defaultValue={"DEFAULT"}
              onChange={(e) => {
                setType(e.target.value);
              }}
            >
              <option value="DEFAULT" disabled>
                Choose Type
              </option>
              <option value="HOTEL">Hotel Room</option>
              <option value="CONFERENCE">Conference Room</option>
            </select>
          </div>
          <div className="image_input">
            {images ? (
              Array.from(images)
                .slice(0, 9)
                .map((e, i) => {
                  return (
                    <img
                      key={i}
                      src={URL.createObjectURL(images[i])}
                      className="left"
                      alt="Preview"
                    />
                  );
                })
            ) : (
              <div className="left"></div>
            )}
            {images?.length > 9 ? (
              <div className="more_images">
                {images.length - 9} more images ...
              </div>
            ) : (
              <></>
            )}
            <div className="right">
              <span>Select the gallerie pictures</span>
              <div
                className="full_button"
                onClick={() => {
                  ref.current.click();
                }}
              >
                Browse
              </div>
            </div>
            <input
              type="file"
              style={{ display: "none" }}
              ref={ref}
              multiple="multiple"
              onChange={(e) => {
                setImages(e.target.files);
              }}
            />
          </div>
          <div className="buttons">
            <div
              className="outlined_button"
              onClick={() => {
                setActive(false);
              }}
            >
              Cancel
            </div>
            <div
              className="full_button"
              onClick={() => {
                post();
              }}
            >
              Create
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const GallerieManager = () => {







  const [active, setActive] = useState(false);
  const [activeT, setActiveT] = useState(1);
  const [hotelRoomsImages, setHotelRoomsImages] = useState([]);
  const [conferenceRoomsImages, setConferenceRoomsImages] = useState([]);

  useEffect(() => {
    toast.promise(
      API.get("/content/gallerieImage").then((resp) => {
        console.log(resp.data.gallerieImages);
        setHotelRoomsImages(
          resp.data.gallerieImages?.filter((e) => e.type === "HOTEL")
        );
        setConferenceRoomsImages(
          resp.data.gallerieImages.filter((e) => e.type === "CONFERENCE")
        );
      }),
      {
        success: "Gallerie pictures fetched succeffully.",
        error: "Something went wrong.",
        loading: "Fetching gallerie pictures.",
      }
    );
  }, []);

  return (
    <div className="galleriemanager">
      {active && <AddImagesModal setActive={setActive} />}
      <div className="pictures">
        <div className="top">
          <h3>Gallerie</h3>
          <div
            className="full_button"
            onClick={() => {
              setActive(true);
            }}
          >
            Add new pictures
          </div>
        </div>
        <div className="hotel_room">
          <div className="mini_navh">
            <span
              onClick={() => setActiveT(1)}
              className={activeT === 1 ? "active" : ""}
            >
              Hotel room pictures
            </span>
            <span
              onClick={() => setActiveT(2)}
              className={activeT === 2 ? "active" : ""}
            >
              Conference room pictures
            </span>
          </div>
          {activeT === 1 && (
            <div className="group_pictures">
              {hotelRoomsImages.length ? (
                hotelRoomsImages.map((e, i) => {
                  return (
                    <div
                      key={i}
                      className="img"
                      
                      onDoubleClick={() => {
                        toast.promise(
                          API.delete("content/gallerieImage/" + e.id).then(
                            () => {
                              setHotelRoomsImages((prev) =>
                                prev.filter((k) => k.id !== e.id)
                              );
                            }
                          ),
                          {
                            success: "Picture deleted succeffuly.",
                            error: "something went wrong.",
                            loading: "Deleting Picutre.",
                          }
                        );
                      }}
                    >
                      <img
                        key={i}
                        src={
                          `${UPLOAD_URL[process.env.NODE_ENV]}${e.picture.filename}`
                        }
                        alt="Hotel Room"
                      />
                    </div>
                  );
                })
              ) : (
                <div className="dump_img"></div>
              )}
            </div>
          )}
        </div>
        {activeT === 2 && (
          <div className="group_pictures">
            {conferenceRoomsImages.length ? (
              conferenceRoomsImages.map((e, i) => {
                return (
                  <div
                    key={i}
                    className="img"
                    onDoubleClick={() => {
                      toast.promise(
                        API.delete("content/gallerieImage/" + e.id).then(() => {
                          setConferenceRoomsImages((prev) =>
                            prev.filter((k) => k.id !== e.id)
                          );
                        }),
                        {
                          success: "Picture deleted succeffuly.",
                          error: "something went wrong.",
                          loading: "Deleting Picutre.",
                        }
                      );
                    }}
                  >
                    <img
                      key={i}
                      src={UPLOAD_URL[process.env.NODE_ENV] + e.picture.filename}
                      alt="Conference Room"
                    />
                  </div>
                );
              })
            ) : (
              <div className="dump_img"></div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default GallerieManager;
